import { render, staticRenderFns } from "./modalConfirmaRecibido.vue?vue&type=template&id=b07f673e&scoped=true"
import script from "./modalConfirmaRecibido.vue?vue&type=script&lang=js"
export * from "./modalConfirmaRecibido.vue?vue&type=script&lang=js"
import style0 from "./modalConfirmaRecibido.vue?vue&type=style&index=0&id=b07f673e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07f673e",
  null
  
)

export default component.exports